module.exports = __webpack_public_path__ + "img/aalto.a13f07ff.png";